import React from 'react';
import clsx from 'clsx';

import styles from './Topography.module.scss';

export type TopographyProps = {
  className?: string;
};

const H2: React.FC<TopographyProps> = ({ className, children }) => (
  <h2 className={clsx(styles.h2, className)}>{children}</h2>
);

const H3: React.FC<TopographyProps> = ({ className, children }) => (
  <h3 className={clsx(styles.h3, className)}>{children}</h3>
);

const H4: React.FC<TopographyProps> = ({ className, children }) => (
  <h4 className={clsx(styles.h4, className)}>{children}</h4>
);

export const Topography = {
  H2,
  H3,
  H4,
};
